const MiscellaneousGeneralMerchandiseStoresIcon = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.037 3.49451L11.647 9.64851M12 17.056V13.0975M15.495 17.056V13.0975M8.4595 17.056V13.0975M19.153 20.5055H4.847L2.75 9.64851H21.25L19.153 20.5055Z"
      stroke="black" strokeWidth="0.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default MiscellaneousGeneralMerchandiseStoresIcon;
